<template>
  <v-row justify="center">
    <v-dialog
      v-model="versionPaymentDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="versionPaymentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>서비스 가격 안내</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="versionPaymentDialog = false">닫기</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-row justify="center">
          <div class="col-10 justify-center" justify="center">
            <v-row>
              <v-col class="pb-0 pt-10">
                <p class="title font-weight-bold pl-0 ml-0 mb-0">
                  정품 인증 서비스 사용 금액
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card outlined>
                  <v-data-table
                    :headers="paymentHeaders"
                    :items="paymentInfoList"
                    hide-default-footer
                    class="elevation-1"
                  ></v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-row>

        <v-row justify="center">
          <div class="col-10 justify-center" justify="center">
            <v-row>
              <v-col>
                <v-card class="blue lighten-5" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-row class="text-center blue--text mb-4 mt-5">
                        <v-col>달라진 브랜딩 효과를 매출로 경험하세요!</v-col>
                      </v-row>
                      <v-row
                        class="headline text-center font-weight-black pb-0 pt-0"
                      >
                        <v-col class="pb-0 pt-0"
                          >정품 인증 서비스를 이용하시면</v-col
                        >
                      </v-row>
                      <v-row class="headline text-center font-weight-black">
                        <v-col class="pt-0 mb-3"
                          >자발적인 회원 가입과 브랜드 관리가 가능합니다.</v-col
                        >
                      </v-row>
                      <v-row class="headline text-center font-weight-black">
                        <v-col class="pb-0 pt-0"
                          >여기저기 흩어진 구매 고객들을 쇼핑몰 회원으로
                          전환시키고</v-col
                        >
                      </v-row>
                      <v-row class="headline text-center font-weight-black">
                        <v-col class="mb-1 pt-0"
                          >충성 고객으로 관리하여 매출을 높여보세요!</v-col
                        >
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <div class="row justify-center mt-0 pt-0 mb-8">
                    <v-btn
                      large
                      color="info"
                      @click="versionPaymentDialog = false"
                      class="saveBtn"
                      style="width:300px"
                      >사용하러 가기</v-btn
                    >
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  methods: {
    versionPaymentCilck: function() {
      this.versionPaymentDialog = true;
    },
  },
  data() {
    return {
      versionPaymentDialog: false,
      notifications: false,
      sound: true,
      widgets: false,

      paymentHeaders: [
        {
          text: "기간",
          align: "center",
          sortable: false,
          value: "days",
          width: "25%",
        },
        {
          text: "할인율",
          align: "center",
          sortable: false,
          value: "discount",
          width: "25%",
        },
        {
          text: "서비스가격",
          align: "center",
          sortable: false,
          value: "service_price",
          width: "25%",
        },
        {
          text: "서비스가격 (VAT포함)",
          align: "center",
          sortable: false,
          value: "service_total_price",
          width: "25%",
        },
      ],
      paymentInfoList: [
        {
          days: "최초 15일",
          discount: "-",
          service_price: "무료",
          service_total_price: "무료",
        },
        {
          days: "1개월",
          discount: "-",
          service_price: "29,000원",
          service_total_price: "31,900원",
        },
        {
          days: "3개월",
          discount: "3%",
          service_price: "84,390원",
          service_total_price: "92,830원",
        },
        {
          days: "6개월",
          discount: "5%",
          service_price: "165,300원",
          service_total_price: "181,830원",
        },
        {
          days: "12개월",
          discount: "7%",
          service_price: "323,640원",
          service_total_price: "356,000원",
        },
      ],
    };
  },
};
</script>
